export const sampleScans = [
  { id: 'S-901', timestamp: '2024-05-20 14:22', area: 'Sector 4', status: 'COMPLETED', energy: 'High', nodes: 12 },
  { id: 'S-902', timestamp: '2024-05-20 15:45', area: 'Old Port', status: 'COMPLETED', energy: 'Low', nodes: 8 },
  { id: 'S-903', timestamp: '2024-05-21 09:10', area: 'Cyber Alley', status: 'WARNING', energy: 'Medium', nodes: 5 },
  { id: 'S-904', timestamp: '2024-05-21 11:30', area: 'Central Hub', status: 'IN_PROGRESS', energy: 'Extreme', nodes: 24 },
];

export const sampleRecords = [
  { name: "Neon Noodle Lab", category: "Dining", synergy: "98%", note: "Best synthetic ramen in Sector 4.", date: "2024-05-22" },
  { name: "Data-Stream Cafe", category: "Workspace", synergy: "82%", note: "High bandwidth, low noise.", date: "2024-05-21" },
  { name: "The Rust Bucket", category: "Historic", synergy: "75%", note: "Authentic pre-collapse architecture.", date: "2024-05-20" },
  { name: "Aero-Club 7", category: "Nightlife", synergy: "91%", note: "Gravity-defying dance floor.", date: "2024-05-22" },
  { name: "Static Garden", category: "Nature", synergy: "64%", note: "Projected flora with real oxygen scrubbers.", date: "2024-05-19" },
];

export const demoSteps = [
  { id: 1, label: 'Initialize Scanner', description: 'Boot up the LocalLens core and establish a satellite uplink to the city grid.' },
  { id: 2, label: 'Target Sector', description: 'Select a neighborhood node (e.g., Sector 4) for deep-packet discovery.' },
  { id: 3, label: 'Filter Constraints', description: 'Set budget ($ to $$$$), energy levels, and transit preferences.' },
  { id: 4, label: 'Sync Peer Nodes', description: 'Aggregate real-time data from trusted local guide networks and friends.' },
  { id: 5, label: 'Generate Route', description: 'Sequence the optimal pathing coordinates for a seamless weekend vector.' },
  { id: 6, label: 'Deploy Protocol', description: 'Push the discovery vector to your tactical device for live navigation.' },
];

export const faqData = [
  {
    q: "How does the 'Scanner' actually find hidden spots?",
    a: "LocalLens aggregates real-time transit data, social sentiment, and P2P node recommendations to identify 'high-synergy' locations that aren't yet saturated by tourist algorithms."
  },
  {
    q: "Is the data in this demo real?",
    a: "No. This is a simulation environment utilizing realistic dummy information to demonstrate the discovery workflow without requiring a live satellite uplink or private data."
  },
  {
    q: "How do I save a discovered location to my databank?",
    a: "Once a 'Scan' is complete, simply tap the 'Memory' icon on any result card to store its coordinates in your permanent collection."
  },
  {
    q: "Does LocalLens track my movement?",
    a: "Privacy is our core protocol. All movement data is masked via our 'Privacy Shield' settings, ensuring your exploration remains anonymous to the central grid."
  },
  {
    q: "Can I share my routes with other nodes?",
    a: "Yes. You can export any generated 'Weekend Planner' sequence as an encrypted link for your trusted P2P network to follow."
  }
];